import { createSelector } from "@reduxjs/toolkit";
import { useRequest, useRequests } from "redux-query-react";
import { getPortfolioComparisonAssociationById, PortfolioComparisonAssociationFromJSON, usePostPortfolioComparisonAssociation } from "api/admin/src";
import { getPortfoliosRaw } from "api/ux/src";
const getQueryConfig = (request) => {
    const config = getPortfolioComparisonAssociationById(request);
    return {
        ...config,
        transform: (body) => {
            // eslint-disable-next-line new-cap
            const value = PortfolioComparisonAssociationFromJSON(body);
            if (value.comparedPortfolioId && value.comparatorPortfolioId) {
                return { PortfolioComparisonAssociation: { [value.id || ""]: value } };
            }
            return {};
        },
        update: { PortfolioComparisonAssociation: (prevValue, transformedValue) => ({ ...prevValue, ...transformedValue }) }
    };
};
const transform = (body) => {
    // eslint-disable-next-line new-cap
    const value = PortfolioComparisonAssociationFromJSON(body);
    return { PortfolioComparisonAssociation: { [value.id || ""]: value } };
};
const update = {
    PortfolioComparisonAssociation: (prevValue, transformedValue) => ({ ...prevValue, ...transformedValue })
};
export const useCustomPostPortfolioComparisonAssociation = () => {
    const [queryState, mutation] = usePostPortfolioComparisonAssociation({ transform, update });
    const mut = (portfolioComparisonAssociation, queryParam) => mutation(portfolioComparisonAssociation, queryParam);
    return [queryState, mut];
};
export const pflAssociationSelector = createSelector((state) => state.entities.PortfolioComparisonAssociation, (_, comparedPortfolioId) => comparedPortfolioId, (portfolioComparisonAssociation, comparedPortfolioId) => Object.values(portfolioComparisonAssociation || {})
    .find((x) => x.comparedPortfolioId === comparedPortfolioId));
export const useGetPortfoliosAndPortfolioComparisonData = (id) => useRequests(id ? [getPortfoliosRaw(), getQueryConfig({ id })] : null);
export const usePortfolioAssociation = (id) => useRequest(id ? getQueryConfig({ id }) : null);
